import { PalletService } from "src/services/pallets";
import { useFileDownload } from "../useFileDownload";

export const usePalletLabelsDownload = (palletService: PalletService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File[]>();

  const downloadFiles = (shipmentId: string, palletIds: string[]) => {
    download({
      getFileData: () => palletService.getPalletLabels(palletIds),
      zipName: `pallet-labels-${shipmentId}.zip`
    });
  };

  return {
    downloadFiles,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
